var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNotificationDiamonds = function SvgNotificationDiamonds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20z",
    fill: "url(#notificationDiamonds_svg__xm14d712qa)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43c10.493 0 19-8.507 19-19S34.493 5 24 5 5 13.507 5 24s8.507 19 19 19z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.066 21.05v.021a.15.15 0 01-.036.072l-.156.178-11.65 13.316-.098.114a.102.102 0 01-.152 0l-.008-.02-.06-.066-12.06-13.29-.216-.238a.155.155 0 01-.036-.07v-.024l.356-.09 11.886-3 11.93 3.018.3.078z",
    fill: "#90D8F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.069 21.047v.022l-.244.082-5.872 1.974H17.689l-5.8-1.954-.306-.104a.12.12 0 010-.024.15.15 0 01.022-.086l.076-.124 2.22-3.618h19.848l2.2 3.6.094.154a.151.151 0 01.022.086l.004-.008z",
    fill: "#B1E4F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.861 19.691h9.918l1.172 3.432h-12.26l1.17-3.432z",
    fill: "#E4F6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.945 23.123l-5.8 11.52-.067.136a.104.104 0 01-.058 0l-.063-.116-6.27-11.538 12.258-.002z",
    fill: "#B1E4F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.74 14.75h-9.846a.153.153 0 00-.068.016l-4.926 2.46 4.958 2.476h9.916l4.958-2.476-4.924-2.476a.153.153 0 00-.068 0z",
    fill: "#90D8F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.74 14.75h-2.69l2.415 1.2a1.42 1.42 0 010 2.54l-2.414 1.2h2.726l4.958-2.476-4.926-2.46a.155.155 0 00-.068-.004z",
    fill: "#75CEF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "notificationDiamonds_svg__xm14d712qa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 17.28) scale(26.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgNotificationDiamonds;